import { render, staticRenderFns } from "./ProjectSended.vue?vue&type=template&id=7ecbb706&lang=pug&"
import script from "./ProjectSended.vue?vue&type=script&lang=js&"
export * from "./ProjectSended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports